<template>
  <div class="world">
    <div class="cards-container">
      <h2 class="text-center">في العالم</h2>
      <b-row >
        <b-col sm="3" cols="12" v-for="s in 4" :key="'world' + s">
          <SingleTours :stars="4"/>
        </b-col>
      </b-row>
      <b-row>
        <div class="see-more">
           <b-button variant="primary">المزيد</b-button>
        </div>
      </b-row>
    </div>
  </div>
</template>
<script type="text/javascript">
  import SingleTours   from '../global/SingleTours'
  export default {
    name:'WorldDestinations',
    components: {
      SingleTours,
    },
  }
</script>
